import React from 'react';
import { useTranslation } from 'react-i18next';
import TitleField from '../../../fields/TitleField';
import DescriptionField from '../../../fields/DescriptionField';
import GallerySelectField from '../../../fields/GallerySelectField';
import GroupSelectField from '../../../fields/GroupSelectField';
import AllowFreeDownloadField from '../../../fields/AllowFreeDownloadField';
import LabelsField from '../../../fields/LabelsField';
import LicenseField from '../../../fields/LicenseField';
import LegalDocumentsField from '../../../fields/LegalDocumentsField';
import DisableCommentsField from '../../../fields/DisableCommentsField';
import ScrapsToggleField from '../../../fields/ScrapsToggleField';
import NotifyWatchersField from '../../../fields/NotifyWatchersField';
import TagsField from '../../../fields/TagsField';
import RecommendedTagsField from '../../../fields/RecommendedTagsField';
import DreamupPromptField from '../../../fields/DreamupPromptField';
import LabelOptionsForm from '../../../common/LabelOptionsForm';
import FieldsGroup from '../../common/FieldsGroup';
import HorizontalSeparator from '../../common/HorizontalSeparator';
import SellFieldsGroup from '../../../fields/SellFieldsGroup';
import FilePreview from '../../common/FilePreview';
import MobileSubmitLayout from '../MobileSubmitLayout';

interface Props {}

const FileSubmitForm: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <MobileSubmitLayout preview={<FilePreview />}>
      <TitleField />
      <LabelOptionsForm />
      <TagsField />
      <RecommendedTagsField withBottomMargin />
      <DreamupPromptField />
      <DescriptionField />
      <GallerySelectField />
      <GroupSelectField />
      <HorizontalSeparator margins="both" />
      <SellFieldsGroup />
      <HorizontalSeparator margins="both" />
      <FieldsGroup
        title={t('deviationSubmit.form.section.advanced.title')}
        isCollapsible
      >
        <LabelsField />
        <LicenseField />
        <LegalDocumentsField />
        <DisableCommentsField />
        <ScrapsToggleField />
        <NotifyWatchersField />
        <AllowFreeDownloadField />
      </FieldsGroup>
    </MobileSubmitLayout>
  );
};
FileSubmitForm.displayName = 'FileSubmitForm';

export default FileSubmitForm;
